<template>
  <div class="navbar">
    <template v-if="isMobile">
      <a-dropdown :trigger="['click']">
        <IconMenu2 :size="24" @click.prevent />

        <template #overlay>
          <a-menu>
            <a-menu-item key="1">
              <router-link
                :to="{ path: '/showcase', query: {status: 'active'} }"
                :class="{ active: $route.query.status === 'active' }"
              >
                <span>Активные проекты</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="2">
              <router-link
                :to="{ path: '/showcase', query: { status: 'completed' } }"
                :class="{ active: $route.query.status === 'completed' }"
              >
                <span>Завершенные проекты</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="3">
              <router-link
                to="/showcase"
                :class="{
                  active: $route.path.indexOf('/portal/publication') > -1,
                }"
              >
                <span>О сервисе</span>
              </router-link>
            </a-menu-item>
            <a-menu-item key="4">
              <router-link to="/">
                <span> Личный кабинет </span>
              </router-link>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>

    <template v-else>
      <ul>
        <li>
          <router-link
            :to="{ path: '/showcase', query: {status: 'active'} }"
            :class="{ active: $route.query.status === 'active' }"
          >
            <span>Активные проекты</span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ path: '/showcase', query: { status: 'completed' } }"
            :class="{ active: $route.query.status === 'completed' }"
          >
            <span>Завершенные проекты</span>
          </router-link>
        </li>
        <li>
          <router-link
            to="/showcase"
            :class="{ active: $route.path.indexOf('/portal/publication') > -1 }"
          >
            <span>О сервисе</span>
          </router-link>
        </li>
      </ul>
      <div>
        <button-dark-border type="external-link" to="/">
          Личный кабинет
        </button-dark-border>
      </div>
    </template>
  </div>
</template>

<script setup>
  import { onBeforeMount, onUnmounted, ref } from 'vue';
  import ButtonDarkBorder from '@/views/portal/components/UI/ButtonDarkBorder.vue';
  import { IconMenu2 } from '@tabler/icons-vue';

  const isMobile = ref(window.innerWidth <= 768);

  onBeforeMount(() => window.addEventListener('resize', handleCheckMedia));
  onUnmounted(() => window.removeEventListener('resize', handleCheckMedia));

  const handleCheckMedia = () => {
    const windowWidth = window.innerWidth;

    isMobile.value = windowWidth <= 768;
  };
</script>

<style lang="scss" scoped>
  .navbar {
    align-items: center;
    display: flex;
    gap: 80px;
    margin-left: auto;

    ul {
      padding: 0;
      margin: 0 -20px;
      list-style-type: none;
      display: flex;
      flex-direction: row;
      li {
        display: block;
        padding: 0;
        a {
          display: block;
          padding: 5px 20px;
          box-sizing: border-box;
          color: #ffffff;
          text-decoration: none;
          text-align: center;

          &:hover,
          &.active {
            span {
              border-bottom: 1px solid #ffffff;
            }
          }

          &:focus {
            outline: none;
            span {
              border-bottom: 1px solid #72c81e;
            }
          }
        }
      }
    }
  }
</style>
